import { forwardRef } from 'react';
import ReactPlayer from 'react-player/lazy';
import CalculateTimeForAutoplayCard from './components/AutoplayCard';
import useVideoAutoplay from './hooks/useVideoAutoplay';
import useVideoProgression from './hooks/useVideoProgression';
import VideoPlayer, { type ICustomPlayer } from './VideoPlayer';

const VideoPlaylistPlayer = forwardRef<ReactPlayer, ICustomPlayer>(({ video, ...restProps }: ICustomPlayer, ref) => {
    const { currentVideo, playNextVideo, getNextVideo } = useVideoAutoplay(video);
    const { registerVideoProgress, registerDuration } = useVideoProgression();
    const upcomingVideo = getNextVideo();

    return (
        <VideoPlayer
            {...restProps}
            video={currentVideo}
            onEnded={playNextVideo}
            onDuration={registerDuration}
            onProgress={({ playedSeconds }) => registerVideoProgress(playedSeconds)}
            ref={ref}
        >
            {!upcomingVideo ? null : <CalculateTimeForAutoplayCard video={upcomingVideo} />}
        </VideoPlayer>
    );
});

export default VideoPlaylistPlayer;
